/** Shared button class strings — single source for Button, chart toolbars, and filter bars. */
export const UI_BTN_BASE =
  'ui-btn inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-focus/15 focus-visible:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none';

export type UiBtnVariant =
  | 'primary'
  | 'secondary'
  | 'outline'
  | 'ghost'
  | 'danger'
  | 'neutral'
  | 'toggle'
  | 'icon';

export function uiBtn(
  variant: UiBtnVariant,
  options?: { pressed?: boolean; size?: 'sm' | 'md' }
): string {
  const size = options?.size === 'sm' ? 'ui-btn--sm' : 'ui-btn--md';

  if (variant === 'toggle') {
    return [UI_BTN_BASE, size, 'ui-btn--toggle', options?.pressed ? 'ui-btn--toggle-active' : '']
      .filter(Boolean)
      .join(' ');
  }

  if (variant === 'icon') {
    return [UI_BTN_BASE, 'ui-btn--icon', options?.pressed ? 'ui-btn--icon-active' : '']
      .filter(Boolean)
      .join(' ');
  }

  return [UI_BTN_BASE, size, `ui-btn--${variant}`].join(' ');
}

/** Segmented control item (speed picker, year picker, etc.) */
export function uiBtnSegment(
  active: boolean,
  _position: 'first' | 'middle' | 'last' | 'only'
): string {
  return [
    UI_BTN_BASE,
    'ui-btn--sm',
    'ui-btn--segment',
    'rounded-sm',
    active ? 'ui-btn--toggle-active' : 'ui-btn--toggle',
  ].join(' ');
}

export type ChartViewKey = 'ranges' | 'percentiles' | 'peaks' | 'density';

/** Outlined chart layer toggle — active color matches graph overlay tokens */
export function uiChartViewBtn(view: ChartViewKey, active: boolean): string {
  return [
    UI_BTN_BASE,
    'ui-chart-view-btn',
    `ui-chart-view-btn--${view}`,
    active ? 'ui-chart-view-btn--active' : '',
  ]
    .filter(Boolean)
    .join(' ');
}
